export * from './event-trigger.component';
export * from './event-trigger.module';
